import { CancelableRequest, WebSocket } from '@shared/services';
import * as Sentry from '@sentry/nextjs';
import { errorToast, errorModal } from '@shared/ui';

export function preinit(role: 'member' | 'merchant' = 'merchant') {
    CancelableRequest.setToastHandler(errorToast);

    CancelableRequest.setModalHandler(errorModal);

    CancelableRequest.setRole(role);

    CancelableRequest.setSentryCaptureException(Sentry.captureException);

    WebSocket.setErrorModal(errorModal);
}
